
<div class="content overflow-hidden">

	<div class="container py-5  text-center" *ngIf="taBody$ | async as taBody;">
		<div [innerHTML]="taBody.body" class="content"></div>
		<!-- <div *ngIf="idOrSlug">{{idOrSlug}}</div> -->
		<div class="">
			<img src="assets/images/compass-403.png" alt="404 error" class="w-md-66">
		</div>
		<a [routerLink]="['/']" class="btn btn-outline-primary pill">Back to Homepage</a>
	</div>


	<div class="container content-inner">

		<ng-template #noSliderListPopular>
			<div class="my-3">No Slider List Popular found.</div>
		</ng-template>

		<ng-container *ngIf="sliderListPopular$ | async as sliderListPopular; else noSliderListPopular">
			<ascedia-swiper-card-image className="mb-5"
				[sliderList]="sliderListPopular"
				[hasFavorites]="false"
				[breakpoints]="breakpoints"
				text="Popular City Tours"
				className="overflow-visible"
				(toggleFavorite)="toggleFavorite($event)"
				>
			</ascedia-swiper-card-image>
		</ng-container>

	</div>

</div>